import { FC } from 'react'
import { AddressResult } from '../../core/domain/providers/IGeocodingProvider'
import Dropdown from './Dropdown'

interface AddressSuggestionListProps {
  suggestions: AddressResult[]
  onSelect: (suggestion: AddressResult) => void
}

const AddressSuggestionList: FC<AddressSuggestionListProps> = (props) => {
  const { suggestions, onSelect } = props
  return (
    <>
      <Dropdown<AddressResult>
        suggestions={suggestions.map((suggestion) => {
          return {
            item: suggestion,
            label: suggestion.formattedAddress
          }
        })}
        onSelect={onSelect}
      />
    </>
  )
}

export default AddressSuggestionList
